import { IEventCashFlowForm } from 'components/organisms/forms/event-cash-flow/EventCashFlowForm';
import { ICreateEventIncome, ICreateEventCost, IUpdateEventIncome, IUpdateEventCost } from 'services/events/types';

export const eventCashFlowFormToQuery = (
  eventCashFlowForm: IEventCashFlowForm,
  type: 'income' | 'cost'
): ICreateEventIncome | ICreateEventCost => {
  const baseData = {
    eventId: eventCashFlowForm.eventId,
    tax: eventCashFlowForm.tax || 0,
    amountGross: eventCashFlowForm.amountGross || 0,
    amountNet: eventCashFlowForm.amountNet || 0,
  };

  if (type === 'income') {
    return {
      ...baseData,
      incomeName: eventCashFlowForm.name,
    } as ICreateEventIncome;
  } else {
    return {
      ...baseData,
      costName: eventCashFlowForm.name,
    } as ICreateEventCost;
  }
};

export const eventCashFlowFormToUpdateQuery = (
  eventCashFlowForm: IEventCashFlowForm,
  type: 'income' | 'cost',
  id: string,
  version: number
): IUpdateEventIncome | IUpdateEventCost => {
  const baseData = {
    version: version,
    tax: eventCashFlowForm.tax || 0,
    amountGross: eventCashFlowForm.amountGross || 0,
    amountNet: eventCashFlowForm.amountNet || 0,
  };

  if (type === 'income') {
    return {
      ...baseData,
      eventIncomeId: id,
      incomeName: eventCashFlowForm.name,
    } as IUpdateEventIncome;
  } else {
    return {
      ...baseData,
      eventCostId: id,
      costName: eventCashFlowForm.name,
    } as IUpdateEventCost;
  }
}; 